// getAllDept,
import {exportPhysician, exportSales, imagingEngineer, salesByPhysician} from '../../../service/service'

export default {
    name: 'management',
    data: function () {
        return {
            total: 0,
            patientName: '',
            dateOfSurgery: '',
            keywordSearch: '',
            searchMark: false,
            timeoutId: '',
            columns4: [
                {
                    title: this.$t('Software'),
                    key: 'software'
                }, {
                    title: this.$t('Expiration Date'),
                    slot: 'expirationdate'
                }, {
                    title: ' ',
                    width: 100,
                    slot: 'action'
                }
            ],
            data4: [
                {
                    software: 'ImmersiveView',
                    expirationdate: '03/16/2020'
                }, {
                    software: 'IVSP',
                    expirationdate: '03/16/2020'
                }, {
                    software: 'ImmersiveTouch',
                    expirationdate: '03/16/2020'
                }, {
                    software: 'ImmersiveTouch',
                    expirationdate: '03/16/2020'
                }
            ],
            columns1: [
                {
                    title: this.$t('name'),
                    key: 'name',tooltip:true
                }, {
                    title: this.$t('email'),
                    key: 'email',tooltip:true
                }, {
                    title: this.$t('phone number'),
                    key: 'phonenumber',tooltip:true
                }, {
                    title: this.$t('admin'),
                    slot: 'admin'
                }
            ],
            data1: [
                {
                    name: 'Anne Lee',
                    email: 'David5789@yahoo.com',
                    phonenumber: '18756523691'
                }, {
                    name: 'Anne Lee',
                    email: 'David5789@yahoo.com',
                    phonenumber: '18756523691'
                }
            ],
            modal: false,
            modal1: false,
            modal2: false,
            modal3: false,
            modal4: false,
            modal5: false,
            modal6: false,
            modal7: false,
            modal8: false,
            modal9: false,
            modal10: false,
            txtComment: '',
            formItem: {
                physician: '',
                specialty: '',
                patientname: '',
                hospital: '',
                dateofsurgery: '',
                priority: false
            },
            note: '',
            ruleInline: {
                patientname: [
                    {required: true, message: this.$t('Please fill in the patient name'), trigger: 'blur'}
                ],
                hospital: [
                    {required: true, message: this.$t('Please select the hospital'), trigger: 'change'}
                ],
                priority: [
                    {required: true, message: this.$t('Please select at priority'), trigger: 'change', type: 'boolean'}
                ]
            },
            modalNext: false,
            fileList: [],
            showTable: '',
            columns2: [
                {
                    title: this.$t('physician'),
                    key: 'physician'
                }, {
                    title: this.$t('specialty'),
                    key: 'specialty'
                }, {
                    title: this.$t('hospital'),
                    minWidth: 100,
                    key: 'hospital'
                }, {
                    title: this.$t('email'),
                    key: 'email',
                    width: 250
                }, {
                    title: this.$t('phone number'),
                    key: 'phoneNumber'
                }, {
                    title: this.$t('total customcases'),
                    key: 'totalCustomCases'
                }, {
                    title: this.$t('Sales Rep Info'),
                    slot: 'admin'
                }
            ],
            data2: [],
            modalName: '',
            modalPhone: '',
            oldEmailLogin: '',
            newEmailLogin: '',
            software: '',
            expirationDate: '',
            newName: '',
            newEmail: '',
            role: '',
            surgery: '',
            pagesize: 20,
            pageTo: 1,
            page: 1,
            row: {},
            myName: 'Mira Liu',
            myCompany: 'Orthopedics',
            hospitalInputList: [
                {hospitalName: ''}
            ],
            salesInfo: {}
        }
    },
    methods: {
        reloadView() {
            let obj = {
                "UserID": this.token,
                "keywordSearch": this.keywordSearch,
                "page": this.page,
                "limit": this.pagesize,
                "tableName": this.showTable
            }
            imagingEngineer.management.getManagementData(obj).then(res => {
                let code = parseInt(res.code)
                if (!code) {
                    // console.log(data)
                    this.$Spin.hide();
                    // console.log(this.showTable)
                    if (this.showTable === 'sales-representative') {
                        let data = JSON.parse(res.data)
                        this.data1 = data
                        this.total = data.length
                    } else {
                        this.data2 = res.data[0]
                        this.total = res.data[0].length
                    }
                    // console.log(JSON.parse(data.list))

                }
            })
        },
        changePageSize(size) {
            this.page = 1
            this.pageTo = 1
            this.pagesize = size
            this.reloadView()
        },
        goPage() {
            if (this.pageTo) {
                let maxPage = Math.ceil(parseInt(this.total) / parseInt(this.pagesize))
                if (parseInt(this.pageTo) > maxPage) {
                    this.page = maxPage
                } else {
                    this.page = parseInt(this.pageTo)
                }
                this.pageTo = this.page
                this.reloadView()
            } else {
                this.pageTo = this.page
            }
        },
        changePage(e) {
            // console.log(e)
            this.page = e
            this.pageTo = e
            this.reloadView()
        },
        delHospital(index) {
            this.hospitalInputList.splice(index, 1)
        },
        addHospital() {
            let obj = {
                hospitalName: ''
            }
            this.hospitalInputList.push(obj)
            // let arr = hospitalInputList
            // arr.push(obj)
            // this.hospitalInputList = arr
        },
        sel(row) {
            console.log(row)
            salesByPhysician({
                userId: this.token,
                doctorId: row.docId
            }).then(res => {
                if (res.code === '1') {
                    this.salesInfo = res.data[0][0]
                }
            })
            this.row = row
            // console.log(e)
            // if(e === 'edit'){
            //     if(this.showTable === 'sales-representative'){
            //         this.modal1 = true
            //     }else{
            //         this.modal8 = true
            //     }
            // }else if(e === 'change'){
            //     this.modal2 = true
            // }else if(e === 'manage'){
            //     this.modal4 = true
            // }else{
            //     this.modal9 = true
            // }
        },
        inviteUser() {
            if (this.showTable === 'sales-representative') {
                this.modal7 = true
            } else {
                this.modal6 = true
            }
        },
        ok10() {
            this.modal10 = false
        },
        ok9() {
            this.modal9 = false
        },
        cancel9() {
            this.modal9 = false
        },
        ok8() {
            this.modal8 = false
        },
        cancel8() {
            this.modal8 = false
        },
        ok7() {
            this.modal10 = true
            this.modal7 = false
        },
        cancel7() {
            this.modal7 = false
        },
        ok6() {
            this.modal10 = true
            this.modal6 = false
        },
        cancel6() {
            this.modal6 = false
        },
        dateChange(e) {
            this.expirationDate = e
        },
        addLicenses() {
            this.modal5 = true
        },
        ok5() {
            this.modal5 = false
        },
        cancel5() {
            this.modal5 = false
        },
        ok4() {
            this.modal4 = false
        },
        cancel4() {
            this.modal4 = false
        },
        ok3() {
            this.modal3 = false
        },
        ok2() {
            this.modal3 = true
            this.modal2 = false
        },
        cancel2() {
            this.modal2 = false
        },
        ok1() {
            this.modal3 = true
            this.modal1 = false
        },
        cancel1() {
            this.modal1 = false
        },
        fileAdded(file) {
            console.log(file, 1)
        },
        delFile(i) {
            this.fileList.splice(i, 1)
        },
        handleUpload(file) {
            console.log(file)
            let arr = this.fileList;
            arr.push(file)
            this.fileList = arr

            return false;
        },
        back() {
            this.modalNext = false
        },
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.$Message.success('Success!');
                    this.modalNext = true
                } else {
                    this.$Message.error('Fail!');
                }
            })
        },
        toCsv() {
            if (this.showTable === 'sales-representative') {
                exportSales({
                    "UserID": this.token,
                    "type": "engineer",
                    "keywordSearch": this.keywordSearch,
                })
            } else {
                exportPhysician({
                    "UserID": this.token,
                    "type": "engineer",
                    "keywordSearch": this.keywordSearch,
                })
            }
        },
        ok() {
            this.modal = false
            this.modalNext = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
        cancel() {
            this.modal = false
            this.formItem.physician = ''
            this.formItem.specialty = ''
            this.formItem.patientname = ''
            this.formItem.hospital = ''
            this.formItem.dateofsurgery = ''
            this.formItem.priority = false
        },
        addCase() {
            this.modal = true
        },
        download(row, index) {
            console.log(row)
            console.log(index)
        },
        showDate() {
            this.page = 1
            this.pageTo = 1
            var that = this;
            if (this.searchMark) {
                clearTimeout(this.timeoutId);
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
            } else {
                this.timeoutId = setTimeout(function () {
                    that.page = 1;
                    that.reloadView();
                }, 1000);
                this.searchMark = true;
            }
        },
        navClick(type) {
            this.showTable = type
            sessionStorage.setItem('showTable', type)
        }
    },
    destroyed() {
        sessionStorage.removeItem('showTable')
    },
    created() {

    },
    mounted() {
        this.showTable = sessionStorage.getItem('showTable') || 'physician'
        this.token = localStorage.getItem('token') || sessionStorage.getItem('token')
        // getAllDept({UserUID: this.token}).then(res=>{
        //     this.specialtylList = res.Dept
        // })
        this.$Spin.show({
            render: (h) => {
                return h('div', [
                    h('Icon', {
                        'class': 'demo-spin-icon-load',
                        props: {
                            type: 'ios-loading',
                            color: '#f48221',
                            size: 18
                        }
                    }),
                    h('div', {
                        style: {
                            color: '#f48221'
                        },
                    }, 'Loading')
                ])
            }
        });
        // eslint-disable-next-line no-irregular-whitespace
        let h = document.body.clientWidth
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.management-modal').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal5').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        document.querySelectorAll('.custom-modal1').forEach(i => {
            // eslint-disable-next-line no-irregular-whitespace
            i.style.zoom = h / 1920 * 100 + '%'
        })
        // eslint-disable-next-line no-irregular-whitespace
        window.onresize = function () {
            // eslint-disable-next-line no-irregular-whitespace
            // console.log(h/1920 * 100 + '%')
            document.querySelectorAll('.custom-modal-details').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal-case').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal2').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
            // eslint-disable-next-line no-irregular-whitespace
            document.querySelectorAll('.custom-modal1').forEach(i => {
                // eslint-disable-next-line no-irregular-whitespace
                i.style.zoom = h / 1920 * 100 + '%'
            })
        }
        this.reloadView()
    }
}
